// To'lov tizimi yo'q — xarid admin bilan Telegram orqali kelishiladi, kirish qo'lda beriladi.
export const PURCHASE_CONTACT_URL = import.meta.env.VITE_PREMIUM_CONTACT_URL || 'https://t.me/fast_support_admin';

/** Kurs va kasblar Alif Nasiya orqali shuncha oyga bo'lib to'lanadi */
export const INSTALLMENT_MONTHS = 6;

/**
 * Oylik to'lov (so'm, butun); narx yo'q yoki 0 bo'lsa null — bo'lib to'lash ko'rsatilmaydi.
 * Pastga yaxlitlanadi: oylik × 6 hech qachon kurs narxidan oshmaydi (499 000 → 83 166 × 6 = 498 996).
 */
export function monthlyInstallment(priceUzs: number | null | undefined): number | null {
  return priceUzs && priceUzs > 0 ? Math.floor(priceUzs / INSTALLMENT_MONTHS) : null;
}
